
const routers = [
    { path: 'acaocomercial', name: 'Ação Comercial', component: function (resolve) { require(['@/views/acaocomercial'], resolve) } },
    { path: 'acaocomercial/create', name: 'Novo Ação Comercial', component: function (resolve) { require(['@/views/acaocomercial/create'], resolve) } },
    { path: 'acaocomercial/edit/:id', name: 'Editar Ação Comercial', component: function (resolve) { require(['@/views/acaocomercial/edit'], resolve) } },

];

export default routers